import React from "react";
import { ThemeProvider, Checkbox, Button } from '@workboard/wobo-ui';
import { withTranslation } from "react-i18next";
import styled from 'styled-components';
import { TypeFaceText } from "../../../inputs/buttons.component";
import {
	RollUpTableComp,
	RollUpKrSearchTableComp
} from "./rolluptable.component";
import SearchBoxComp from "../../../inputs/searchbox.component";
import GoalServices from "../../../../services/goal.services";
import { ErrorTextComp } from "../../../inputs/fields.component";
import { reactLoader, removeReactLoader, constructNestedKRPayload } from "../../../../utils/common.js";
import DeleteCommonModal from '../../../../components/deleteCommonModal.component';
import KrAlignDependance from '../../../../components/okr/wizard/key_results/krAlignDependence';
import MetricOwnerCommonModal from "./metric-owner.component";
import NestedInlineComp from "./NestedInline.component";
import DropdownComp from "../../../dropdown/dropdown";
import AddKrTag from "../../../../krTags/components/addkrTag.component";
import PermissionComp from './permission.component';
import Customokr from "../../../custom_fields/customobj/Customokr";
import KrRelationshipWrapper from "./krRelationshipWrapper";
import KrMilestonesSection from './KrMilestonesSection';
import { MultipleKrCoOwnerSelect } from "./MultipleKrCoOwnerSelect";
import { AddFinancialTargetsButton } from '../AddFinancialTargetsButton';
import { isKrDurationChangedFromSaved } from '../../../../utils/krQuarterDuration'
import { isKeyResultClosed } from '../../../../utils/closeKeyResult.util';
import { DurationSelect } from '../DurationSelect';
import { resolveDurationSelectInitial, resolveKrDuration } from '../goalPeriodRows';

const MIRROR_KR_TYPE = "mirror_kr";

const StyledCheckbox = styled(Checkbox)`
  .MuiButtonBase-root {
    width: 24px;
    height: 24px;
    margin-left: -5px;
  }
  svg {
    width: 24px;
    height: 24px;
  }
`;
class LinkedKrComp extends React.Component {
	constructor(props) {
		super(props);
		const isKrCoOwnerEnabled = window.wbConfig.isKrCoOwnerEnabled ?? false;
		const initialKrDuration = resolveKrDuration(
			this.props.item,
			this.props.goalDetails,
			''
		);
		let metricMirror = [];
		if (Object.keys(this.props.item).length) {
			metricMirror = this.props.item.metricMirror || [];
		}
		this.state = {
			metricMirror,
			errors: {},
			confirmPopup: false,
			krAlingSelected: this.props.item &&
				this.props.item.kr_aligns !== undefined &&
				this.props.item.kr_aligns.length > 0
				? this.props.item.kr_aligns
				: [],
			krDependenciesSelected: this.props.item &&
				this.props.item.kr_dependent !== undefined &&
				this.props.item.kr_dependent.length > 0
				? this.props.item.kr_dependent
				: [],
			realOwner: {
				id: this.props.item && this.props.item.real_owner
					? this.props.item.real_owner
					: this.props.basicInlineData && this.props.basicInlineData.owner
						? this.props.basicInlineData.owner
						: this.props.goalDetails.owner_id,
				name: this.props.item && this.props.item.real_owner_fullname
					? this.props.item.real_owner_fullname
					: this.props.basicInlineData && this.props.basicInlineData.ownerName
						? this.props.basicInlineData.ownerName
						: this.props.goalDetails.owner_fullname,
				avatar: this.props.item && this.props.item.real_owner_pic
					? this.props.item.real_owner_pic
					: this.props.basicInlineData && this.props.basicInlineData.ownerPic
						? this.props.basicInlineData.ownerPic
						: this.props.goalDetails.owner_pic,
			},
			tags:[],
			Exclude:
         this.props.item && this.props.item.progress_consider == 0
          ? true
          : false,
		  permissionHelpPopUp: false,
		  hide: false,
		  teamPermissionSelected:
			this.props.item && this.props.item.permission_teams
				? this.props.item.permission_teams
				: this.props.goalDetails.type == 1 &&
						this.props.goalDetails.default_permission_teams &&
						Object.keys(this.props.goalDetails.default_permission_teams).length > 0
						? this.props.goalDetails.default_permission_teams : [],
		  bizPermissionSelected:  this.props.item && this.props.item.permission_biz ? this. props.item.permission_biz : [],
		 permission: [],
		 permissionstate:
		  this.props.item && this.props.item.permission
			? this.props.item.permission.split(",").map(Number)
			: this.props.goalDetails.type == 1 ? (this.props.goalDetails.default_permission &&
			  Object.keys(this.props.goalDetails.default_permission).length > 0 ? this.props.goalDetails.default_permission.split(",").map(Number) : [8])  : [10],
		 applyObjKr:
		  this.props.goalDetails && this.props.goalDetails.all_metrics == 1
			? true
			: false,
		nplTags:this.props.nplTags ? this.props.nplTags : [],
		selectednlplTags:this.props.selectednlplTags ? this.props.selectednlplTags : [],
		selectednlplTagsName:this.props.selectednlplTagsName ? this.props.selectednlplTagsName : [],
		tagsList:this.props.tagsList ? this.props.tagsList:[],
		customFiledRequired:false,
      isCustomSave:[],
      isRequirdCustomOkr:[],
      customInputData:[],
	  kr_durationOption: this.props.goalDetails.annualQuarterOption
      ? this.props.goalDetails.annualQuarterOption
      : '',
	  kr_duration: initialKrDuration || '',
	  isQuarter: initialKrDuration?.isQuarter ?? false,
	  isAnuualQChange:false,
	  coOwners: isKrCoOwnerEnabled ? (this.props.item.coOwners && this.props.item.coOwners.length > 0 ? this.props.item.coOwners : (this.props.coOwners && this.props.coOwners.length > 0 ? this.props.coOwners : [])) : [],
	  enableCoOwner: isKrCoOwnerEnabled && this.props.item.coOwners && this.props.item.coOwners.length > 0 ? true : false,
	  checkRolFlag: this.props.item?.is_real_owner_rol != undefined ? true : false,
	  milestones: this.props.item?.milestones ?? [],
	};
		this.GoalServices = new GoalServices();

		this.renderSearchKR = this.renderSearchKR.bind(this);
		this.clickKrItem = this.clickKrItem.bind(this);
		this.removeKr = this.removeKr.bind(this);
		this.saveLinkedKR = this.saveLinkedKR.bind(this);
		this.exitDeleteModal = this.exitDeleteModal.bind(this);
		this.saveItems = this.saveItems.bind(this);
		this.saveAlignArr = this.saveAlignArr.bind(this);
		this.saveDependentArr = this.saveDependentArr.bind(this);
		this.handleExcludeChange = this.handleExcludeChange.bind(this);
		this.permissionData = this.permissionData.bind(this);
		this.teamPermissionData = this.teamPermissionData.bind(this);
		this.updateTags = this.updateTags.bind(this);
		this.isRequiredCustomOkrFiled = this.isRequiredCustomOkrFiled.bind(this);
		this.isSaveCustom =this.isSaveCustom.bind(this)
		this.renderError = this.renderError.bind(this);

		this.saveLinkedKRCompleted = this.saveLinkedKRCompleted.bind(this);
		this.getMilestonesPayload = this.getMilestonesPayload.bind(this);
		this.handleMilestonesChange = this.handleMilestonesChange.bind(this);
	}

	componentWillUnmount() {
		this.props.metricRef(null)
	}

	setSavedAnnualDuration(quarterName){
		let kr_dur = quarterName ? this.state.kr_durationOption && this.state.kr_durationOption.filter(element => {
		  return element.quarter_name ==quarterName
		}):
		this.state.kr_durationOption && this.state.kr_durationOption.filter(element => {
		  return element.quarter_name =="";
		})
	  if(kr_dur) {
		  this.setState({
			kr_duration:{
			  start:kr_dur[0].start,
			  end:kr_dur[0].end,
			  name:kr_dur[0].name,
			  year:kr_dur[0].year,
			  value:kr_dur[0].value,
			  qname: kr_dur[0].quarter_name,
			  isQuarter:kr_dur[0].isQuarter
			},
		  })
		  this.setState({isQuarter: kr_dur[0].isQuarter})
	  }

	  }
	componentDidMount() {
		if (this.props.item?.id) {
			const krDuration = resolveKrDuration(
				this.props.item,
				this.props.goalDetails,
				this.state.kr_duration
			);
			if (krDuration?.start) {
				this.setState({
					kr_duration: krDuration,
					isQuarter: krDuration.isQuarter,
				});
			}
		} else if (this.props.item?.quarter_name) {
			this.setSavedAnnualDuration(this.props.item.quarter_name);
		}
		this.props.metricRef(this)
	}

	permissionData(perData) {
		this.setState({
		  permissionstate: perData
		});
	}

	teamPermissionData(teamPerData) {
		this.setState({
			teamPermissionSelected: teamPerData
		});
	}

	updateTags(Newtags){
		this.setState({
		  selectednlplTagsName: Newtags
		})
	}

	bizPermissionData = (bizPerData) => {
		this.setState({
			bizPermissionSelected: bizPerData
		});
	}

	renderSearchKR(values = [], inst) {
		if (values.length) {
			let attr = {};
			attr.rowClick = this.clickKrItem;
			return values.map(m => (
				<RollUpKrSearchTableComp key={"render_search_" + m.id} value={m} attr={attr} inst={inst} />
			));
		} else {
			return null;
		}
	}

	clickKrItem(e, item, searchboxInstance) {
		//$(e.target).trigger("mouseleave");
		//console.log('e.target', e.target);
		$(e.target).trigger("mouseleave");
		if (searchboxInstance) {
			searchboxInstance.closeBox();
		}
		this.setState({ metricMirror: [item], errors: {} });
	}

	removeKr(e, item) {
		this.setState({ metricMirror: [] });
	}

	addParamsForParentKR(params, parent){
		if(parent){
			params.start_date = this.props.childKrDuration.start;
			params.end_date = this.props.childKrDuration.end;
			params.parent = this.props.item.parent;
		}
		return params;
	}

	getMilestonesPayload() {
		// Ensure milestones is an array before attempting to use array methods
		if (!Array.isArray(this.state.milestones)) {
			return '';
		}
		// milestones need to be an object with keys as index and values as milestone object (for api request)
		const milestonesList = this.state.milestones
		  .filter((milestone) => milestone.date && (milestone.target == 0 || milestone.target))
		  .reduce((acc, milestone, index) => ({
				...acc,
				[index]: {
					id: milestone.id && typeof milestone.id === 'number' ? milestone.id : null,
					date: milestone.date,
					label: milestone.label,
					target: milestone.target,
				}
		  }), {});

		// if there are no milestones, return an empty string (for api request)
		return Object.keys(milestonesList).length > 0 ? milestonesList : '';
	}

	handleMilestonesChange(milestones) {
		this.setState({ milestones });
	}

	saveLinkedKRCompleted(callback = null, data = {}) {
		if (callback && typeof callback === 'function') {
			callback(data);
		} else {
			this.props.closeKrRightPane(true);
		}
	}

	saveLinkedKR(callback = null) {
		let { metricMirror, krAlingSelected, krDependenciesSelected, coOwners  } = this.state;
		let errors = {},
			params = {};
		this.isSaveCustom(this.state.customInputData)
		this.setState({isCustomSave:[]})
		const { t } = this.props;
		if (!metricMirror.length) {
			errors["mirror_kr"] = t('Select a key result');
			let elem = document.getElementById("existing-kr-search-box");
       		 elem.setAttribute("aria-invalid", "true");
			setTimeout(() => {
				document.getElementById("existing-kr-search-box").focus();
			});
			this.setState({ errors });
		}
		else {
			// Validate realOwner using role flags or ownerList
			if (this.state.realOwner && this.state.realOwner.id) {
				let shouldValidateRealOwner = false;
				// Only validate if checkRolFlag is true (initial load or when role flags are present)
				if (this.state.checkRolFlag) {
					// Check if we have role flags from the KR item
					if (this.props.item && this.props.item.is_real_owner_rol !== undefined) {
						shouldValidateRealOwner = this.props.item.is_real_owner_rol;
					}
					if (shouldValidateRealOwner) {
						const realOwnerName = this.state.realOwner.name || 'Unknown User';
						errors['real_owner_validation'] = `${realOwnerName} has Read Only access and can't be assigned KRs`;
						this.setState({ checkRolFlag: false });
					} else {
						delete errors['real_owner_validation'];
					}
				} else {
					// If checkRolFlag is false, clear any existing errors
					delete errors['real_owner_validation'];
				}
			}
			let { actions, item, goalDetails, krType, lastType, addEditFlag } = this.props;
			if (krType != lastType && addEditFlag) {
				this.setState({
					confirmPopup: true,
				})
			} else if (isKrDurationChangedFromSaved(this.props.item, this.state.kr_duration, this.props.goalDetails)) {
				this.setState({
				  confirmPopup: true,
				  isAnuualQChange:true,
				})
			  } else {
			  let teaMperArr = [], bizPerArr = [];
			  if (this.props.goalDetails && this.props.goalDetails.all_metrics == 1) {
				const { permission_teams = [], permission_biz = []} = this.props.goalDetails;
				if (Array.isArray(permission_teams) && permission_teams.length) {
				  teaMperArr = permission_teams.map(val => val.id);
				}
				if (Array.isArray(permission_biz) && permission_biz.length) {
				  bizPerArr = permission_biz.map(val => val.id);
				}
			} else {
				teaMperArr = this.state.teamPermissionSelected.map(val => val.id);
				bizPerArr = this.state.bizPermissionSelected.map(val => val.id);
			}
			params.permission_teams = teaMperArr;
			params.permission_biz = bizPerArr;
			if (this.props.goalDetails && this.props.goalDetails.all_metrics == 1) {
				params.permission = this.props.goalDetails.permission;
			} else {
				params.permission = Array.prototype.map
				.call(this.state.permissionstate, s => s)
				.toString(); // "A,B,C";
			}
			if( this.state.isRequirdCustomOkr && this.state.isRequirdCustomOkr.length>0 ){
				errors["customokr"] = t(`Please enter required field`);
				this.setState({isCustomSave:this.state.isRequirdCustomOkr})
				setTimeout(() => {
					this.setState({customFiledRequired:true})
					document.querySelector('#cutomobj').scrollIntoView({
					  behavior: 'smooth',
					})
				}, 200)

			}
			else {
				let goalId = goalDetails.id;
				if(typeof goalId == "undefined") return;
				let krId = "";
				let _this = this;
				if (typeof item !== "undefined" && typeof item["id"] !== "undefined") {
					params.id = item["id"];
					krId = params.id;
				}
				params.source = 11;
				params.progress_consider = this.state.Exclude ? 0 : 1;
				params.mirror_kr_id = metricMirror.map(k => k.id).join("");
				if (metricMirror && metricMirror[0] && typeof metricMirror[0].committed_target != 'undefined') {
					params.committed_target = metricMirror[0].committed_target;
				}
				let krAlignSel = krAlingSelected;
				let dependentKrsSel = krDependenciesSelected;
				let krAligns = [];
				let dependentKrs = [];
				if (krAlignSel !== undefined && Object.keys(krAlignSel).length > 0) {
					krAlignSel.map(krItem => {
						krAligns.push(krItem.id);
					});
				}

				if (dependentKrsSel !== undefined && Object.keys(dependentKrsSel).length > 0) {
					dependentKrsSel.map(depItem => {
						dependentKrs.push(depItem.id);
					});
				}
				params.krAligns = krAligns;
				params.dependentKr = dependentKrs;
				let nlpIds =this.state.selectednlplTagsName && this.state.selectednlplTagsName.length ? this.state.selectednlplTagsName : ['']
				let tagids=this.state.tags.length ? this.state.tags : ['']
				let finalTagsIds = [...nlpIds,...tagids]
				params.krTagIds = finalTagsIds;
				params["nested_krs"] = constructNestedKRPayload(this.props);
				// Include milestones data if available
				params.milestones = this.getMilestonesPayload();
				params.real_owner = this.state.realOwner.id;
				params.coOwners = coOwners.length > 0 ? Array.prototype.map
				  .call(coOwners, s => s.id)
				  .toString() : '';
				params.customField = JSON.stringify(this.props.customFieldsData);
				params.kr_duration=this.state.kr_duration;
				params.isQuarter=this.state.isQuarter;
				params.isPeriodChange=this.state.isAnuualQChange
				if(this.props.isChildKr && this.props.fromParentKr){
					params.duration = this.props.childKrDuration;
					params.real_owner_fullname = this.props.showRealOwner ? this.state.realOwner.name : "";
					params.real_owner_pic = this.props.showRealOwner ? this.state.realOwner.avatar : "";
					params.metricMirror = metricMirror;
					params.name = metricMirror && metricMirror[0] ? metricMirror[0].name :"";
					if(this.props.item.parent){
						params.parent = this.props.item.parent;
					}
					params.coOwnersDetails = coOwners?.length > 0 ? coOwners : [];
					this.props.saveNestedKr(params, this.props.nestedKrIndex, this.props.nestedKrAction);
				} else if(this.props.mitChildKr){
					params.duration = this.props.childKrDuration;
					params.real_owner_fullname = this.props.showRealOwner ? this.state.realOwner.name : "";
					params.real_owner_pic = this.props.showRealOwner ? this.state.realOwner.avatar : "";
					params.metricMirror = metricMirror;
					params.target = metricMirror && metricMirror[0] ? metricMirror[0].target : 0;
					params.name = metricMirror && metricMirror[0] ? metricMirror[0].name :"";
					this.props.saveQuarterlyKR(params, this.props.mitIndex);
					this.saveLinkedKRCompleted(callback, params);
					// this.props.closeKrRightPane();
				} else{
					params = this.addParamsForParentKR(params, this.props.item.parent);
					reactLoader(true);
					this.GoalServices.addEditKr({ goalId: goalId, metric: params }).then(
						response => {
							removeReactLoader();
							if(!response.data || this.props.onlyMetEdit) {
								// _this.props.closeKrRightPane(true);
								this.saveLinkedKRCompleted(callback, null);
								return false;
							}

							let result = response.data.data;
							let krWeightage = null;
							if (result.krWeightage) {
								krWeightage = result.krWeightage;
								delete result['krWeightage'];
							}
							if(result.parent) {
								actions.addUpdateNestedKr(result)
							} else {
								krId ? actions.editNewKr(krId, result) : actions.addNewKr(result);
							}

							if (krWeightage) {
								_this.props.MetricChangeWeight(krWeightage);
							}
							// _this.props.closeKrRightPane(true);
							this.saveLinkedKRCompleted(callback, result);
						}
					);
				}
			}
		}
	}
	}

	exitDeleteModal() {
		//console.log('exitmodel');
		this.setState({ confirmPopup: false });
	}
	saveItems() {
		let { actions, item, goalDetails, krType, lastType, addEditFlag, coOwners } = this.props;
		let goalId = goalDetails.id;
		let { metricMirror, krAlingSelected, krDependenciesSelected } = this.state;
		let params = {};
		let krAlignSel = krAlingSelected;
		let dependentKrsSel = krDependenciesSelected;
		let krAligns = [];
		let dependentKrs = [];
		params.kr_duration=this.state.kr_duration;
		params.isQuarter=this.state.isQuarter;
		params.isPeriodChange=this.state.isAnuualQChange
		if (krAlignSel !== undefined && Object.keys(krAlignSel).length > 0) {
			krAlignSel.map(item => {
				krAligns.push(item.id);
			});
		}
		if (dependentKrsSel !== undefined && Object.keys(dependentKrsSel).length > 0) {
			dependentKrsSel.map(item => {
				dependentKrs.push(item.id);
			});
		}
		params.krAligns = krAligns;
		params.dependentKr = dependentKrs;
		// Include milestones data if available
		params.milestones = this.getMilestonesPayload();
		if (typeof goalId !== "undefined") {
			let krId = "";
			let _this = this;
			if (typeof item !== "undefined" && typeof item["id"] !== "undefined") {
				params.id = item["id"];
				krId = params.id;
			}
			params.source = 11;
			params.progress_consider = this.state.Exclude ? 0 : 1;
			params.mirror_kr_id = metricMirror.map(k => k.id).join("");
			let nlpIds =this.state.selectednlplTagsName && this.state.selectednlplTagsName.length ? this.state.selectednlplTagsName : ['']
			let tagids=this.state.tags.length ? this.state.tags : ['']
			let finalTagsIds = [...nlpIds,...tagids]
			params.krTagIds = finalTagsIds;
			params["nested_krs"] = constructNestedKRPayload(this.props);
			params.real_owner = this.state.realOwner.id;
			let coOwners = this.props.coOwners && this.props.coOwners.length > 0 ? this.props.coOwners : [];
			params.coOwners = coOwners.length > 0 ? Array.prototype.map
			  .call(coOwners, s => s.id)
			  .toString() : '';
			let teaMperArr = [], bizPerArr = [];
			if (this.props.goalDetails && this.props.goalDetails.all_metrics == 1) {
				const { permission_teams = [], permission_biz = []} = this.props.goalDetails;
				if (Array.isArray(permission_teams) && permission_teams.length) {
				  teaMperArr = permission_teams.map(val => val.id);
				}
				if (Array.isArray(permission_biz) && permission_biz.length) {
				  bizPerArr = permission_biz.map(val => val.id);
				}
			} else {
				teaMperArr = this.state.teamPermissionSelected.map(val => val.id);
				bizPerArr = this.state.bizPermissionSelected.map(val => val.id);
			}
			params.permission_teams = teaMperArr;
			params.permission_biz = bizPerArr;
			if (this.props.goalDetails && this.props.goalDetails.all_metrics == 1) {
				params.permission = this.props.goalDetails.permission;
			} else {
				params.permission = Array.prototype.map
				.call(this.state.permissionstate, s => s)
				.toString(); // "A,B,C";
			}
			params.customField = JSON.stringify(this.props.customFieldsData);
			if(this.props.isChildKr && this.props.fromParentKr){
				//params.ownerName = this.state.data_provider.name;
				params.duration = this.props.childKrDuration;
				params.real_owner_fullname = this.props.showRealOwner ? this.state.realOwner.name : "";
				params.real_owner_pic = this.props.showRealOwner ? this.state.realOwner.avatar : "";
				params.metricMirror = metricMirror;
				params.name = metricMirror && metricMirror[0] ? metricMirror[0].name :"";
				if(this.props.item.parent){
					params.parent = this.props.item.parent;
				}
				params.coOwnersDetails = coOwners?.length > 0 ? coOwners : [];
				this.props.saveNestedKr(params, this.props.nestedKrIndex, this.props.nestedKrAction);
			} else if(this.props.mitChildKr){
				params.duration = this.props.childKrDuration;
				params.target = metricMirror && metricMirror[0] ? metricMirror[0].target : 0;
				params.real_owner_fullname = this.props.showRealOwner ? this.state.realOwner.name : "";
				params.real_owner_pic = this.props.showRealOwner ? this.state.realOwner.avatar : "";
				params.metricMirror = metricMirror;
				params.name = metricMirror && metricMirror[0] ? metricMirror[0].name :"";
				this.props.saveQuarterlyKR(params, this.props.mitIndex);
          		this.props.closeKrRightPane();
			} else{
				if(this.props.item.parent){
					params.start_date = this.props.childKrDuration.start ;
					params.end_date = this.props.childKrDuration.end;
					params.parent = this.props.item.parent;
				}
				reactLoader(true);
				console.log('params', params)
				this.GoalServices.addEditKr({ goalId: goalId, metric: params }).then(
					response => {
						removeReactLoader();
						this.setState({
							confirmPopup: false,
							isAnuualQChange:false,
						  });
						if (response.data) {
							this.setState({ confirmPopup: false });
							if (!this.props.onlyMetEdit) {
								let result = response.data.data;
								let krWeightage = null;
								if (result.krWeightage) {
									krWeightage = result.krWeightage;
									delete result['krWeightage'];
								}
								if(result.parent){
									actions.addUpdateNestedKr(result)
								}else{
									if (krId) {
										actions.editNewKr(krId, result);
									} else {
										actions.addNewKr(result);
									}
								}
								if (krWeightage) {
									_this.props.MetricChangeWeight(krWeightage);
								}
							}
							_this.props.closeKrRightPane(true);
						}
					}
				);
			}
		}
	}

	renderError(field) {
		return <ErrorTextComp errors={this.state.errors} field={field} />;
	}

	getErrorClass(field) {
		return (typeof this.state.errors[field] !== 'undefined') ? ' errorBorder  ' : '';
	}

	saveAlignArr(alignData) {
		this.setState({
			krAlingSelected: alignData
		})
	}
	saveDependentArr(dependentData) {
		this.setState({
			krDependenciesSelected: dependentData
		})
	}

	isSaveCustom(isVal){
		let arr=[];
		let j=0;
		let keyArrCategory=[]
		let valArray = []
		isVal && Object.keys(isVal).forEach((v)=>{
		  j++;
		  isVal[v]["customFields"]&&
		  Object.keys(isVal[v]["customFields"]).forEach(objv=>{
			keyArrCategory.push(objv)
			if(isVal[v]["customFields"][objv]['is_required']=='1'
			&&( isVal[v]["customFields"][objv]["text"]  ==undefined || isVal[v]["customFields"][objv]["text"]  ==[])
			){
				 arr.push(objv,v)
				}
			if(isVal[v]["customFields"][objv]["text"]){
			  valArray.push(isVal[v]["customFields"][objv]["text"])
			}else{
			  valArray.push('')
				}
		  })
		  if(j==Object.keys(isVal).length){
			this.setState({isRequirdCustomOkr:[...arr]})
		  }
		  let finalDataArray=[]
		  for(let i=0;i<valArray.length;i++){
			if(Array.isArray(valArray[i])){
			  valArray[i].forEach(val => {
				finalDataArray.push({id:keyArrCategory[i],val:val.name,object_type:'6'})
			  })
			}
			else{
			  finalDataArray.push({id:keyArrCategory[i],val:valArray[i],object_type:'6'})
			}

		  }
		  const tempData=finalDataArray
		})

	  }

		isRequiredCustomOkrFiled(isVal,id){
		  let cust_id=this.state.isCustomSave.find((u) => u == id);
		  let ar=this.state.isCustomSave ? this.state.isCustomSave:'';
		  let fr= ar.filter(
			  (u) => u != cust_id
			)
		  this.setState({isCustomSave:fr})
		  this.isSaveCustom(isVal)
		  this.setState({customInputData:isVal})
		}
	updateRealOwner = (data) => {
		console.log('updateRealOwner called with:', data);
		this.setState({
			realOwner: {
			id: data.userId,
			name: data.userText,
			avatar: data.userPic,
			},
			checkRolFlag: false
		})
		console.log('Calling showRolErr(false) from updateRealOwner');
		// Note: linkedkr doesn't have showRolErr prop, so we'll handle error clearing differently
	}
	updateCoOwner = (data) => {
		if (data.length > 0) {
		  this.setState({
			coOwners: data,
		  })
		} else {
		  this.setState({
			coOwners: []
		  })
		}
	  }
	saveTag = (childData) =>{
		this.setState({tags:childData})
	}
	changeMetricDurationVal(from, data, text) {
		if(data){
			this.setState({
			  kr_duration:{
				start:data.start,
			   end:data.end,
				name:data.name,
				year:data.year,
				value:data.value,
				qname: data.quarter_name,
				isQuarter:data.isQuarter,
				isCustom: !data.year && data.value === undefined,
			  },
			 })
		}
    this.setState({isQuarter: data.isQuarter})
	this.removeKr()
  }
	handleExcludeChange() {
		this.setState({
		  Exclude: !this.state.Exclude
		});
	  }

	render() {
		let rows = this.state.metricMirror;
		let goal = this.props.goalDetails;
		let krId = "";
		if (typeof this.props.item !== "undefined" && typeof this.props.item["id"] !== "undefined") {
			krId = this.props.item["id"];
		}
		const {t, addOkrData} = this.props;
		const { permission = ''} = addOkrData.goalDetails || {};
		const isOrgViewPermission = permission.split(',').filter(v => v == 8).length;
		const isKrCoOwnerEnabled = window.wbConfig.isKrCoOwnerEnabled ?? false;
		const durationSelectInitial = resolveDurationSelectInitial(
			this.props.item,
			this.props.goalDetails,
			this.state.kr_duration
		) || {
			start: moment.utc(this.props.goalDetails.start_date).toISOString(),
			end: moment.utc(this.props.goalDetails.target_date).toISOString(),
		};
		const { isAnnualMit, isMitEdit, dateSegment } = this.props;
		const useMitDateSegment = (isAnnualMit || isMitEdit) && dateSegment;
		let searchStartDate = '';
		let searchEndDate = '';
		if (this.props.isChildKr && this.props.childKrDuration.start) {
			searchStartDate =  moment(this.props.childKrDuration.start, "MM/DD/YYYY").format("MMM DD, YYYY");
			searchEndDate =  moment(this.props.childKrDuration.end, "MM/DD/YYYY").format("MMM DD, YYYY");
		} else if (useMitDateSegment) {
			searchStartDate = dateSegment.startDate;
			searchEndDate = dateSegment.endDate;
		} else {
			// Any selected duration scopes the search, not just quarters (OKR-11253);
			// the fallback only covers a duration that never resolved to a period row.
			searchStartDate = this.state.kr_duration?.start || goal.start_date;
			searchEndDate = this.state.kr_duration?.end || goal.target_date;
		}
		return (
			<div className="linkedkr-comp-wrapper">
				{/* {
					this.props.showRealOwner &&
					<>
						<div className="metricOwner labeltext-25px">Person responsible for business result</div>
						<MetricOwnerCommonModal item={this.state.realOwner} updateData={this.updateRealOwner} />
						{this.renderError("krOwner")}
					</>
				} */}
				<div className="addEditKrPanelRow">
					{
						this.props.showRealOwner &&
						<div>
							<div className="metricOwner">{t('Person responsible for business result')}</div>
							<MetricOwnerCommonModal addId="linkedMetrictarttargetsecId" item={this.state.realOwner} updateData={this.updateRealOwner} coOwners ={this.state.coOwners} teamId={this.props.goalDetails.team_id}/>
							{this.renderError("krOwner")}
							{this.renderError("real_owner_validation")}
							<div className="durationSelect" style={{ marginTop: '21px'}} >

                      </div>
						</div>
					}
					{
						(this.props.isChildKr || this.props.mitChildKr) ?
						<div style={{marginLeft: this.props.showRealOwner ? "10px" : 0 }}>
						<div className="metricOwner">{t('Duration')}<span className="text-style-1">*</span></div>
						{!this.props.mitChildKr ? (
						<DropdownComp
							//labelText="Show:"
							wrapperClass = "durationDropdown"
							defaultValue={this.props.childKrDuration ? this.props.childKrDuration.value: 0}
							options={this.props.goalDetails.metricQuarterOption}
							onChange={(e, item) => this.props.updateChildKrDuration(item)}
							appendId="linked-kr-duration"
						/>) :
						(
							<div className="durationSupportingKR">
							  {
								this.props.goalDetails.metricQuarterOption[
								  this.props.mitIndex % 4
								].name
							  }
							</div>
						  )}
						</div>:
						    <>
								{this.state.kr_durationOption &&
									<DurationSelect
										isKr={true}
										id="dropdowncomp-btn-kr-duration"
										style={{minHeight: '64px', marginTop: '21px'}}
										disabled={this.props.item?.canChangeDuration === false}
										initialValue={durationSelectInitial}
										onChange={(data) => {
											this.changeMetricDurationVal('kr_duration', data)
										}}
										minAllowedDate={moment.utc(this.props.goalDetails.start_date).toISOString()}
										maxAllowedDate={moment.utc(this.props.goalDetails.target_date).toISOString()}
									/>
								}
							</>
					}
					 {isKrCoOwnerEnabled && !this.state.enableCoOwner && <Button
							style={{marginLeft: 'auto',marginTop: '52px'}}
							variant="secondary"
							isDisabled={isKeyResultClosed(this.props.item)}
							onClick={()=>
							{
								if (!this.state.enableCoOwner) {
								this.setState({ enableCoOwner: true })
								} else{
								this.setState({ enableCoOwner: false })
								}
							}
							}
							>
							<img  style={{marginRight: '4px'}} src={`${wbConfig.imageCdnUrl}/images/Group.svg`}/>
							{t('Add Co-owners')}
						</Button>}
				</div>
				<div style={{display:'flex', flexDirection:'row'}}>
					{this.state.enableCoOwner &&
						<div>
							<div className="metricOwner">
								{t("Who's co-owning this result?")}
							</div>
							<MultipleKrCoOwnerSelect
							isMitChildKr={this.props.mitChildKr}
							realOwnerId={this.state.realOwner.id}
							coOwners ={this.state.coOwners}
							updateData={this.updateCoOwner}
							teamId={this.props.goalDetails.team_id}
							/>
						</div>
					}
				</div>

				{!isKeyResultClosed(this.props.item) && <div className="fieldcontent">
					<div className="labeltext-25px">
					{t('Find an existing key result to link directly to')}
						<TypeFaceText />
					</div>
					<div className="">
						<SearchBoxComp
							minLength="0"
							expandSearchBox={true}
							wrapperClass="linked-kr-box"
							url={"goal/searchKrs?type=mirror_kr&goal_start=" + searchStartDate + "&goal_end=" + searchEndDate + "&krId=" + krId}
							inputProps={{
								placeholder: t('Search for key result key result owner, or team'),
								className: this.getErrorClass('mirror_kr')
							}}
							params = {{limit: 5}}
							loginUser={this.props.addOkrData && this.props.addOkrData.userData && this.props.addOkrData.userData.id}
							renderResultComp={this.renderSearchKR}
							parentKRID={this.props.parentKRID}
							id={this.props.item.id}
							type={MIRROR_KR_TYPE}
							searchBoxId='existing-kr-search-box'
						/>
						{this.renderError("mirror_kr")}
					</div>
				</div>}



				{rows.length ? (
					<div className="fieldcontent">
						<div className="labeltext-25px">{t('Selected key result')}{rows.length > 1 ? `(s):` : `:`}</div>
						<div className="width-600px">
							{rows.map(r => (
								<RollUpTableComp
									key={"mirror_kr_" + r.id}
									type="kr"
									tableClass="rollup-kr-table"
									row={r}
									showProgress={false}
									removeItem={isKeyResultClosed(this.props.item) ? false : this.removeKr}
								/>
							))}
						</div>
						{
							this.props.addOkrData.showCommittedTarget &&  rows[0].committed_target && rows[0].committed_target == 1 &&
							<div className="committedKRMirror">{`${t("You're mirroring a committed key result.")} ${t('This result will also be committed.')}`}</div>
						}
						{
							!isOrgViewPermission &&
							<div className="committedKRMirror">{`${t("You're mirroring a key result with restricted view permissions.")} ${t('Adjust your OKR view permissions as needed to share this result with the right audience.')}`}</div>
						}
						{(this.props.customData && Object.keys(this.props.customData).length > 0 && !this.props.mitChildKr) && <div className="krBreak" style={{marginBottom:"-10px"}} aria-hidden="true" />}
        				{  ((this.props.addOkrData.groupKRCustomFields|| this.props.groupKRCustomFields) && !this.props.mitChildKr )&&
									<Customokr
										customData={this.props.customData}
										isRequiredCustomOkrFiled={this.isRequiredCustomOkrFiled}
										onCustomDataChange={(newData) => this.props.onCustomFieldsChange?.(newData)}
										customFiledRequired={true}
										renderError={this.renderError}
										isCustomSave={this.state.isCustomSave}
									/>
        				}
					</div>
				) : (
						""
					)}
				{
					this.state.confirmPopup &&
					<DeleteCommonModal
						exitDeleteModal={this.exitDeleteModal}
						deleteItems={this.saveItems}
						id=""
						title={t(this.state.isAnuualQChange ? 'Save Key Result with new duration' : 'Save Key Result with New Data Type')}
						deleteContentOne=""
						deleteContentSecondParam=""
						deletefirstTitle=""
						deleteContentSecond={t(this.state.isAnuualQChange
              ? 'Are you sure you want to change the duration on this Key Result? This will eliminate all Updates and Confidence Flags on the Key Result.'
              : 'Are you sure you want to save this key result with the new data type you selected? This will get rid of past key result data.')}
         			  	buttonText={t(this.state.isAnuualQChange ? 'Change duration' : 'Save')}
					/>

				}
				{!this.props.mitChildKr && !this.props.isChildKr && (
					<KrMilestonesSection {...this.props} metricState={this.state} metric={this.props.item} onChange={this.handleMilestonesChange} />
				)}
				{!this.props.mitChildKr && <KrRelationshipWrapper {...this.props} metric={this.props.item} saveKr={this.saveLinkedKR}/>}
				<AddFinancialTargetsButton objectType="kr" objectId={this.props.item?.id} ownerUserId={this.state.realOwner?.id} />
				{!this.props.mitChildKr && <AddKrTag metric={this.props.item} goalId={this.props.goalDetails.id} taghandler={this.saveTag}
				nplTags={this.state.nplTags}  selectednlplTags={this.state.selectednlplTags} selectednlplTagsName={this.state.selectednlplTagsName} updateTags={this.updateTags} tagsList={this.state.tagsList} searchText={this.props.krText}
				/> }
				{
					(this.props.addOkrData.display_nested_kr &&
					!this.props.isChildKr && !this.props.mitChildKr &&
					Math.ceil(moment(this.props.goalDetails.target_date).diff(moment(this.props.goalDetails.start_date), "days", true)) >= 360) &&
					<>
						<div className="krBreak"  aria-hidden="true" style={{marginTop: 15}} />
						<NestedInlineComp
						{...this.props}
						actions = {this.props.actions}
						nested_krs = {this.props.nested_krs}
						updateNestedKrs = {this.props.updateNestedKrs}
						/>
					</>
				}
				{
					!this.props.isChildKr && !this.props.mitChildKr &&
					<KrAlignDependance {...this.props}
					saveDependentArr={this.saveDependentArr}
					saveAlignArr={this.saveAlignArr}
					krAlingArr={this.props.item.kr_aligns}
					krDependenciesArr={this.props.item.kr_dependent} />
				}
				{
              !this.props.isChildKr && !this.props.mitChildKr &&
              <div className="excludeProgressArea">
                <ThemeProvider>
                  <StyledCheckbox
                    id='excludePro'
                    label={`${t('Exclude from objective progress calculation')}`}
                    onChange={this.handleExcludeChange}
                    isChecked={this.state.Exclude ? true : false}
                  />
                </ThemeProvider>
              </div>
            }
			{!this.state.applyObjKr && !this.props.isChildKr && (
              <div className="viewPermissionArea">
                <span>
                  {t('View permissions in addition to')}{" "}
                  {this.props.goalDetails.type == 1 ? ` ${t('team ')}` : ` ${t('owner')} `}
                  <div
                    className="metricTargetHelptext permissionHelpText"
                    onMouseEnter={event => {
                      this.setState({ permissionHelpPopUp: true });
                    }}
                    onMouseLeave={event => {
                      this.setState({ permissionHelpPopUp: false });
                    }}
                  />
                  {this.state.permissionHelpPopUp && (
                    <div className="basic-popup">
                      {t(`You can give your whole organization permission to view your Key Result, or just your team and managers`)}
                    </div>
                  )}
                </span>
              </div>
            )}

            {!this.state.applyObjKr && !this.props.mitChildKr && (
              <PermissionComp
                {...this.props}
                teamPermissionData={this.teamPermissionData}
                bizPermissionData={this.bizPermissionData}
                permissionData={this.permissionData}
                hide={this.state.hide}
              />
            )}

			</div>
		);
	}
}

export default withTranslation()(LinkedKrComp);
